import { createFileRoute } from '@tanstack/react-router';

import { buildBreadcrumbSchema, buildSeoHead, buildWebPageSchema, jsonLdScript, ROUTE_META } from '@src/corelib/seo';

export const Route = createFileRoute('/compare/crowdstrike')({
  head: () => ({
    ...buildSeoHead({ path: '/compare/crowdstrike', ...ROUTE_META['/compare/crowdstrike'] }),
    scripts: [
      jsonLdScript(buildBreadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'Compare', path: '/compare' }, { name: 'CrowdStrike', path: '/compare/crowdstrike' }])),
      jsonLdScript(buildWebPageSchema({ path: '/compare/crowdstrike', ...ROUTE_META['/compare/crowdstrike'] })),
    ],
  }),
});
